export const PatientConstants = {
    GETPATIENTS_REQUEST : 'GETPATIENTS_REQUEST',
    GETPATIENTS_SUCCESS : 'GETPATIENTS_SUCCESS',
    GETPATIENTS_FAILURE : 'GETPATIENTS_FAILURE',

    CREATEPATIENTS_REQUEST : 'CREATEPATIENTS_REQUEST',
    CREATEPATIENTS_SUCCESS : 'CREATEPATIENTS_SUCCESS',
    CREATEPATIENTS_FAILURE : 'CREATEPATIENTS_FAILURE',

    SELECTED_PATIENT: 'SELECTED_PATIENT',
    RESET_PATIENT:'RESET_PATIENT' 
}


// WEBPACK FOOTER //
// ./src/store/constants/patients.constant.js